import React from "react"
import DfbRte from "../ui-kit/dfb_rte"
import DfbAnchor from "../ui-kit/dfb_anchor"
import CMediaVideo from "../elements/c_media_video"
import Section from "./section"
import PageContext from "../page-context"
import { t } from "../../i18n-utility"

const MTextmedia = (props) => {
  return (
    <Section
      baseClass="m-TextMedia"
      className={
        props.data.reverse === "reverse" ? "m-TextMedia--reverse" : undefined
      }
      defaultPaddingTop="small"
      data={props.data}
    >
      <div className="m-TextMedia-wrapper">
        <div className="m-TextMedia-container">
          <div className="m-TextMedia-content">
            <div className="m-TextMedia-textContainer">
              <div className="m-TextMedia-text">
                {props.data.text && (
                  <DfbRte text={props.data.text} add_class="m-TextMedia-rte" />
                )}
                {props.data.anchor &&
                  props.data.anchor !== "//-/id-1" &&
                  props.data.anchor !== "//-/id-INVALID-" && (
                    <PageContext.Consumer>
                      {({ translations }) => (
                        <DfbAnchor
                          tagName="a"
                          link={props.data.anchor}
                          text={t(translations, "dfb_anchor.morelink")}
                          add_class="m-TextMedia-anchor"
                        />
                      )}
                    </PageContext.Consumer>
                  )}
              </div>
              <div className="m-TextMedia-mediaWrapper">
                {props.data.video_embed_id && (
                  <CMediaVideo video_embed_id={props.data.video_embed_id} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MTextmedia
